import React, { useState, useEffect } from 'react';
import {Modal} from 'antd';
import ProductList from '../../../../pages/Plans/planList/page';
import {trackEvent} from '../../../../analytics/posthog';

const SubscriptionModal: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleShow = () => {
            setVisible(true);
            window.dispatchEvent(new CustomEvent('reset-subscription-flow'));
        };

        const handleHide = () => setVisible(false);

        window.addEventListener('show-subscription-modal', handleShow);
        window.addEventListener('hide-subscription-modal', handleHide);
        return () => {
            window.removeEventListener('show-subscription-modal', handleShow);
            window.removeEventListener('hide-subscription-modal', handleHide);
        };
    }, []);

    return (
        <Modal title="No Active Subscription" open={visible}
            onCancel={() => setVisible(false)} footer={null} width={1000}
        >
            <p>You need an active subscription to perform this action.</p>
            <ProductList/>
        </Modal>
    );
};

export default SubscriptionModal;

export const showSubscriptionModal = () => {
    trackEvent('user_trial_start_opened');
    window.dispatchEvent(new CustomEvent('close-all-modals'));
    window.dispatchEvent(new CustomEvent('show-subscription-modal'));
};

export const hideSubscriptionModal = () => {
    window.dispatchEvent(new CustomEvent('hide-subscription-modal'));
};
